import ImprovementClarificationTable from './ImprovementClarificationTable';

const ProductHydro = ({ refreshTrigger }) => (
  <ImprovementClarificationTable
    procurementTypeHeader='1'
    refreshTrigger={refreshTrigger}
  />
);

export default ProductHydro;
